import { useAppSelector } from "../../../utils/hooks";

export default function Participants() {
  const ConnectedUser = useAppSelector((state) => state.ConnectedUser);

  const getInitials = (name: string) =>
    (name || "?")
      .trim()
      .split(/\s+/)
      .slice(0, 2)
      .map((p) => p.charAt(0).toUpperCase())
      .join("") || "?";

  return (
    <div className="flex h-full w-full flex-col overflow-y-auto px-1 py-3">
      <div className="mb-3 px-2 text-xs font-medium uppercase tracking-wider text-lightText/60">
        In call ({ConnectedUser.length})
      </div>
      <div className="flex flex-col gap-1.5">
        {ConnectedUser.map((user) => {
          const initials = getInitials(user.full_name);
          return (
            <div
              key={user.user_id}
              className="flex items-center gap-3 rounded-xl border border-borderColor/60 bg-secondary/60 p-2.5 transition hover:bg-secondary"
            >
              {user.profile_image ? (
                <img
                  className="h-10 w-10 rounded-full object-cover ring-2 ring-themeColor/40"
                  src={user.profile_image}
                  alt=""
                />
              ) : (
                <div className="grid h-10 w-10 place-content-center rounded-full bg-gradient-to-br from-indigo-500 via-purple-500 to-pink-500 text-xs font-semibold text-white ring-2 ring-white/20">
                  {initials}
                </div>
              )}
              <div className="min-w-0 flex-1">
                <div className="truncate text-sm font-medium">
                  {user.full_name}
                </div>
                <div className="truncate text-xs text-lightText/60">
                  @{user.user_name}
                </div>
              </div>
              <span className="flex items-center gap-1.5 rounded-full bg-emerald-500/15 px-2 py-0.5 text-[10px] font-medium text-emerald-500">
                <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
                Online
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
